module.exports = {
  title: '产品信息管理',
  route: {
    path: 'platform-goods-manage',
    children: {
      path: 'platform-goods-list',
    },
  },
};
